import React, { useState } from "react";

import {
    Create,
    TextInput,
    ReferenceInput,
    SimpleForm,
    required,
    useRedirect,
    useNotify,
    useRefresh,
    SaveButton,
    Toolbar,
    AutocompleteInput,
    DateInput,
    NumberInput,
    SelectInput,
} from "react-admin";



import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";
import { GenericTable } from "../__common/GenericTable";
import { AntibioticInterpretationField } from "./AntibioticInterpretationField";
import { DiscreteAntibioticInterpretationField } from "./DiscreteAntibioticInterpretationField";


const ExternalIsolateCreateToolbar = (props) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const refresh = useRefresh();

    return (
        <Toolbar {...props}>
            <SaveButton
                label="Save"
                submitOnEnter={false}
                onSuccess={({ data }) => {
                    // if not empty, redirect to the sample show view
                    if (data.id_sample !== "") {
                        notify(
                            `External Isolate created, redirecting to External isolates view`
                        );
                        sleep(2000).then(() => {
                            redirect(`/External_isolates`);
                            refresh();
                        });
                    } else {
                        notify(
                            `External Isolate created, redirecting to External isolates list`
                        );
                        sleep(2000).then(() => {
                            redirect(`/External_isolates`);
                            refresh();
                        });
                    }
                }}
            />
            <span>&nbsp;</span>
            <SaveButton
                label="Save & add another"
                onSuccess={({ data }) => {
                    notify(`External Isolate created, redirecting to "create" view`);
                    sleep(2000).then(() => {
                        redirect(`/External_isolates/create`);
                        refresh();
                    });
                }}
                // transform={(data) => ({
                //   ...data,
                //   code: `${props.id_sample}.${data.id_culture}.${data.code}`, // TODO HACER QUE ESTO SE VEA EN EL CAMPO CODIGO
                // })}
                submitOnEnter={true}
            />
        </Toolbar>
    );
};

export const ExternalIsolatesCreate = (props) => {
    const [reload, setReload] = useState(0);

    const onChange = ()=>{
        setReload(p => p + 1);
    }

    return (
        <Create {...props} actions={<MyCreateActions />} >
            <SimpleForm onChange={onChange} >
                <TextInput sx={{ display: "block" }} label="Code" source="code" />
                <TextInput label="Code external" source="code_external" />
                <TextInput label="Type external" source="type_external" />
                <ReferenceInput
                    label="Provider"
                    source="id_provider"
                    reference="providers"
                    validate={required()}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="name"
                        suggestionLimit={9999}
                    />
                </ReferenceInput>

                <TextInput label="Specie" source="specie" />
                <TextInput label="Study source" source="study_source" />

                <DateInput label="Study date" source="study_date" />

                <TextInput label="Notes" source="notes" multiline minRows={6} />

                {/* Storage */}
                <div className="">STORAGE</div>
                <TextInput
                    source="isolates_storages.cryobox_name"
                    label="Cryobox name"
                />
                <NumberInput
                    source="isolates_storages.cryobox_size"
                    label="Size"
                    initialValue="81"
                />
                <TextInput
                    source="isolates_storages.cryobox_position"
                    label="Position"
                />
                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Storage"
                    source="isolates_storages.id_storage"
                    reference="storages"
                >
                    <SelectInput optionText="storage" />
                </ReferenceInput>
                <TextInput
                    source="isolates_storages.notes"
                    label="Notes"
                    multiline
                    minRows={6}
                />
                <br></br>
                <div>No discretos</div>
                <br></br>
                {
                    <GenericTable
                        reload={reload}
                        collectionName="antibiotics_interpretations"
                        body={{
                            id: undefined,
                            mic_interpretation: undefined,
                            mic_operator: undefined,
                            mic_value: undefined,
                            notes: undefined,
                        }}
                        headers={["Antibiotic", "Interpretation", "Mic Operator", "Mic Value", "Notes"]}
                        genericTableRow={AntibioticInterpretationField}
                    >
                    </GenericTable>
                }
                <br></br>
                <div>Discretos</div>
                <br></br>
                {
                    <GenericTable
                        collectionName="antibiotics_discrete"
                        body={{
                            id: undefined,
                            mic_interpretation: undefined,
                            notes: undefined
                        }}
                        headers={["Antibiotic", "Interpretation", "Notes"]}
                        genericTableRow={DiscreteAntibioticInterpretationField}
                    >
                    </GenericTable>
                }
            </SimpleForm>
        </Create>
    );
};

export const isDiscrete = (element) => {
    return element.mic_interpretation === 'P' || element.mic_interpretation === 'N'
}



